import { useEffect, useState } from 'react'

const useParams = () => {
  const [mode, setMode] = useState<string>('')
  const [form, setForm] = useState<string>('')

  useEffect(() => {
    const url = new URL(globalThis.location.href)
    const params = new URLSearchParams(url.search)
    const paramMode = params.get('mode')
    const paramForm = params.get('form')

    if (paramMode) setMode(paramMode)
    if (paramForm) setForm(paramForm)
  }, [])

  return { mode, form }
}

export default useParams
